







































import Vue, { PropType } from 'vue';

import { BaseUser } from '@/models';
import {
  copiedEmailsMessage,
  copyEmailsLabel,
  rosterEmails
} from '@/rosterEmails';

export default Vue.extend({
  props: {
    members: {
      type: Array as PropType<BaseUser[]>,
      required: true
    },

    // Left out when every role is copied.
    roleName: String,

    // Duplicate group only asks to be opened: the dialog lives on the
    // profile page, which outlasts this menu when the original is archived.
    canDuplicate: Boolean
  },

  data() {
    return {
      toast: { open: false, message: '' }
    };
  },

  computed: {
    emails(): string[] {
      return rosterEmails(this.members);
    },

    copyLabel(): string {
      return copyEmailsLabel(this.emails.length, this.roleName);
    }
  },

  methods: {
    async copy() {
      // Taken before the await, so the message counts what was written.
      const emails = this.emails;
      const message = copiedEmailsMessage(emails.length, this.roleName);

      // A disabled list item only blocks clicks with CSS.
      if (emails.length === 0) {
        return;
      }

      try {
        await navigator.clipboard.writeText(emails.join(', '));
        this.toast = { open: true, message };
      } catch (error) {
        this.toast = { open: true, message: 'Could not copy emails' };
      }
    }
  }
});
